import React from 'react'

const StepVerification = () => (
    <div style={{ marginTop: '100px', marginBottom: '100px' }} id="stepContainer" className="stepContainer has-text-centered"><h3>Thank you!</h3></div>
)

export default StepVerification